export default "/images/8dd4035888c130a6e2a8c8547d1f33bf.avif";